<form [formGroup]="signinForm" class="hero-form-sign-in" (ngSubmit)="send()">
  <input class="hero-input-text hero-input-context-password" type="text" formControlName="email" placeholder="Deine email" dictionary="placeholder_email" />
  <input class="hero-input-password" type="password" formControlName="password" placeholder="Dein Passwort" dictionary="placeholder_password" />
  <div class="additional d-flex justify-content-between">
    <label><input type="checkbox" class="hero-form-check" formControlName="remember" /> <span class="label-text" dictionary="remember_me">merken</span></label>
    <a class="hero-link" routerLink="/forgot-password" dictionary="forgot_password">Passwort vergessen?</a>
  </div>
  <button class="btn btn-hero btn-hero-primary" type="submit" [disabled]="disabled" dictionary="sign_in" [ngClass]="{'error' : error}">Anmelden</button>
</form>
